import TableList from "@components/templates/tablelist";
import compFBAInDetail from '../fbatransfer/update.vue';
import compFBAOutDetail from '../fbatransfer/updateout.vue';
import compOrdinaryInDetail from '../ordinarytransfer/update.vue';
import compOrdinaryOutDetail from '../ordinarytransfer/updateout.vue';
import {
    HttpSubManageBillList,
    HttpSubApprovePlanBill,
    HttpCancelPlanBill,
    HttpCompletePlanBill,
    HttpReprocessPlanBill,
    HttpBackToNormalPlanBill,
    HttpGetManageBillSpan
} from "@/service/allotment";
import mixin from "../mixin";
import {
    mapGetters
} from "vuex";
export default {
    mixins: [TableList, mixin],
    components: {
        compFBAInDetail,
        compFBAOutDetail,
        compOrdinaryInDetail,
        compOrdinaryOutDetail,
    },
    data() {
        return {
            isMixin: true,
            Tools: {
                show: true
            },
            Tabs: {
                show: true
            },
            formData: {
                search: {
                    'quanbu': 0,
                }
            },
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: {
                show: true
            },
            spanTabs: { show: true },
            spanAjaxRequest: HttpGetManageBillSpan,
        };
    },
    methods: {
        ajaxRequest: HttpSubManageBillList,
        interceptRequest(params) {
            return this.handleParams(params);
        },
        handleParams(params) {
           const { trackingNo, CN_subTransferPlanNo, sku, orderTypes} = params.search;
           params.trackingNo = trackingNo;
           params.sku = sku;
           params.orderTypes = orderTypes;
           delete params.search.trackingNo;
           delete params.search.orderTypes;
           let IN_subTransferPlanNo, arr1, arr2=[];
           if(CN_subTransferPlanNo){
               arr1 = CN_subTransferPlanNo.split(/\n/);
               arr1.map(item=>{
                   if(item){
                       arr2.push(item)
                   }
               })
               if(arr2.length>0){
                   IN_subTransferPlanNo = arr2.toString()
               }
           }
           if( arr2.length > 151 ){
                this.$Message.error(this.$t("erp.b2c.alert_morethan150", { defaultValue: "调拨计划单号输入不能超过150条" }));
                IN_subTransferPlanNo = ''
           }
           delete params.search.CN_subTransferPlanNo
           params.search.IN_subTransferPlanNo = IN_subTransferPlanNo;
           if (params.search.quanbu === 0) {
              params.search.EQ_subTransferPlanStatus = '';
           }
           if (params.search.error === 1) {
               params.search.IN_errorCode = [1,2];
           }else if(params.search.error === 3){
               params.search.IN_errorCode = [3,4];
           }else if(params.search.error === 5){
               params.search.EQ_errorCode = 5;
           }else if(params.search.error === 7){
               params.search.IN_errorCode = [6,7];
           }else if(params.search.error === 8){
               params.search.IN_errorCode = [8,9];
           }else if(params.search.error === 11){
               params.search.IN_errorCode = [11,12];
           }else if(params.search.error === 14){
               params.search.IN_errorCode = [14,15];
           }else if(params.search.error === 18){
               params.search.EQ_errorCode = 18;
           }else if(params.search.error === 19){
               params.search.IN_errorCode = 19;
           }else if(params.search.error === 20){
                params.search.IN_errorCode = 20;
            }
           delete params.search.error
           delete params.search.quanbu
           delete params.search.sku
           return params
        },
        handleOperates(params = "", type, batch) {
            if (batch === true) {
                params = (params || this.checkedData.join(',')) + '';
                if (!params.length) return this.$VMessage.warning(this.$t('global.common.choose_one', { defaultValue: '请选择至少一条数据' }));
            }
            switch (type) {
                case "query":
                    this.operate = {
                        title: this.$t('fbb.alloment.detail', { defaultValue: '详情' }),
                        show: true,
                        width: 1200,
                        component: params.type == 0 ? 'compFBAOutDetail' : params.type == 1 ? 'compFBAInDetail' : (params.type == 2 && params.orderType == 2) ? 'compOrdinaryInDetail' : 'compOrdinaryOutDetail',
                        activeid: params.id,
                        isManage: true,
                        alertbox: true,
                        querytype: 'query',
                        showFooter: false
                    }
                break;
                case 'queryBlank':
                    window.open(this.$router.resolve({
                        name: params.type == 0 ? 'fbaTransferOutDetail' : params.type == 1 ? 'fbaTransferInDetail' : (params.type == 2 && params.orderType == 2) ? 'ordinaryTransferInDetail' :'ordinaryTransferOutDetail',
                        params: {
                            type: 'query'
                        },
                        query: {
                            id: params.id,
                            isManage: true
                        },
                    }).href, '_blank');
                break;
                case "cancel":
                    this.operate = {
                        show: true,
                        alert: "error",
                        title: this.$t('global.common.operate_cancel', { defaultValue: "取消" }),
                        width: 460,
                        showDesc: false,
                        params: {
                            id: params
                        },
                        ajaxRequest: HttpCancelPlanBill,
                        formdata: [{
                            tag: "vTextarea",
                            key: "cancelReason",
                            labelWidth: 'auto',
                            span: 24,
                            label: this.$t('fbb.alloment.cancel_reason', { defaultValue: "取消原因" })
                        }]
                    };
                break;
                case "approve":
                    this.operate = {
                        show: true,
                        alert: "info",
                        title: this.$t('fbb.alloment.button_audit', { defaultValue: "审核" }),
                        width: 'middle',
                        showDesc: false,
                        params: {
                            ids: params.id
                        },
                        ajaxRequest: HttpSubApprovePlanBill,
                        formdata: [{
                                tag: "vRadio",
                                key: "actionType",
                                span: 24,
                                label: this.$t('fbb.alloment.button_audit', { defaultValue: "审核" }),
                                labelWidth: 120,
                                default: 500,
                                options: [{
                                    label: this.$t('fbb.inbound.pass_audit', { defaultValue: "审核通过" }),
                                    trueValue: 500
                                }, {
                                    label: this.$t('fbb.inbound.back_audit', { defaultValue: "审核拒回" }),
                                    trueValue: 600
                                }]
                            },
                            {
                                label: this.$t('fbb.alloment.warehouse_out_bound_at', { defaultValue: "预计出库日期"  }),
                                tag: "vDatepicker",
                                key: "warehouseEstimateOutboundAt",
                                labelWidth: 120,
                                show:params.orderType==1,
                                span: 24,
                                props: {
                                    format: "yy-mm-dd",
                                },
                                required: true,
                            },
                            {
                                tag: "vTextarea",
                                key: "reason",
                                labelWidth: 120,
                                span: 24,
                                label: this.$t('global.common.notes', { defaultValue: "备注" }),
                                required: false,
                            }
                        ]
                    };
                break;
                case "batchApprove":
                    this.operate = {
                        show: true,
                        alert: "info",
                        title: this.$t('fbb.alloment.button_audit', { defaultValue: "审核" }),
                        width: 'middle',
                        showDesc: false,
                        params: {
                            ids: params
                        },
                        ajaxRequest: HttpSubApprovePlanBill,
                        formdata: [{
                                tag: "vRadio",
                                key: "actionType",
                                span: 24,
                                label: this.$t('fbb.alloment.button_audit', { defaultValue: "审核" }),
                                labelWidth: 120,
                                default: 500,
                                options: [{
                                    label: this.$t('fbb.inbound.pass_audit', { defaultValue: "审核通过" }),
                                    trueValue: 500
                                }, {
                                    label: this.$t('fbb.alloment.refuse_audit', { defaultValue: "审核拒回" }),
                                    trueValue: 600
                                }]
                            },
                            {
                                label: this.$t('fbb.alloment.warehouse_out_bound_at', { defaultValue: "预计出库日期" }),
                                tag: "vDatepicker",
                                key: "warehouseEstimateOutboundAt",
                                labelWidth: 120,
                                show:params.orderType==1,
                                span: 24,
                                props: {
                                    format: "yy-mm-dd",
                                },
                                required: true,
                            },
                            {
                                tag: "vTextarea",
                                key: "reason",
                                labelWidth: 120,
                                span: 24,
                                label: this.$t('global.common.notes', { defaultValue: "备注" }),
                                required: false,
                            }
                        ]
                    };
                break;
                case 'complete':
                    this.operate = {
                        show: true,
                        alert: "error",
                        title: this.$t('global.common.finish', { defaultValue: "完成" }),
                        width: 460,
                        showDesc: false,
                        params: {
                            id: params
                        },
                        ajaxRequest: HttpCompletePlanBill,
                        formdata: [
                            {
                                tag: "vTextarea",
                                key: "completeReason",
                                labelWidth: 'auto',
                                span: 24,
                                label: this.$t('global.common.notes', { defaultValue: "备注" })
                            }
                        ]
                    };
                break;
                case 'reprocess':
                    this.operate = {
                        show: true,
                        alert: "error",
                        title: this.$t('fbb.alloment.reprocess', { defaultValue: "重处理" }),
                        width: 400,
                        showDesc: true,
                        params: {
                            id: params,
                            type:2
                        },
                        ajaxRequest: HttpReprocessPlanBill,
                    };
                break;
                case 'backToNormal':
                    this.operate = {
                        show: true,
                        alert: "info",
                        title: this.$t('fbb.alloment.back_to_normal', { defaultValue: "忽略异常" }),
                        width: 400,
                        showDesc: true,
                        params: {
                            id: params,
                            type:2
                        },
                        ajaxRequest: HttpBackToNormalPlanBill,
                    };
                break;
                case 'export':
                    this.handleParams(this.formData)
                    this.handleWebfs(process.env.VUE_APP_APIURL_FBB + '/api/v2/SubTransfer/batchExport', this.formData, {
                        executor: 'request',
                        download: true,
                        method: 'post',
                    })
                break;
            }
        },
        getOperateNodeMap(row) {
            const { id, subTransferPlanStatus: status, orderType: orderType, errorCode, type} = row
            return [
                {
                    label: this.$t('fbb.alloment.query_detail', { defaultValue: '查看详情' }),
                    show: true,
                    params: {id, orderType, type},
                    operate: 'query'
                },
                {
                    label: this.$t('fbb.alloment.button_audit', { defaultValue: '审核' }),
                    show: status == 5,
                    params: {id,orderType},
                    operate: 'approve'
                },
                {
                    label: this.$t('global.common.finish', { defaultValue: '完成' }),
                    show: status == 10 || status == 15 || status == 20 || status == 25,
                    params: id,
                    operate: 'complete'
                },
                {
                    label: this.$t('fbb.alloment.reprocess', { defaultValue: '重处理' }),
                    show: errorCode !== 0,
                    params: id,
                    operate: 'reprocess'
                },
                {
                    label: this.$t('fbb.alloment.back_to_normal', { defaultValue: '忽略异常' }),
                    show: errorCode !== 0,
                    params: id,
                    operate: 'backToNormal'
                }
                /* , {
                label: '取消',
                show: status == 10,
                params: id,
                operate: 'cancel'
                } */
            ]
        },
    },
    computed: {
        ...mapGetters('dictionary', ['getBillcusWareList','getBillcusAndFbaWareList','getUserManageWarehouseList','getSelfmanageorgList','getSysAllList', 'getCusproductList', 'getOrgList']),
        TabsData() {
            return [{
                name: this.$t('fbb.alloment.all', { defaultValue: "所有" }),
                key: 'quanbu',
                value: 0,
            }, {
                name: this.$t('fbb.alloment.audit', { defaultValue: "待审核" }),
                key: 'EQ_subTransferPlanStatus',
                value: 5,
                spanKey: 'submittedQty',
            },
            {
                name: this.$t('fbb.transfer.preparedgoods', { defaultValue: "待备货" }),
                key: 'EQ_subTransferPlanStatus',
                value: 9,
                spanKey: 'readyQty',
            },{
                name: this.$t('fbb.alloment.wait_for_outbound', { defaultValue: "待出库" }),
                key: 'EQ_subTransferPlanStatus',
                value: 10,
                spanKey: 'confirmedQty',
            }, {
                name: this.$t('fbb.alloment.outbounding', { defaultValue: "出库中" }),
                key: 'EQ_subTransferPlanStatus',
                value: 15,
                spanKey: 'outboundQty',
            }, {
                name: this.$t('fbb.alloment.wait_for_inbound', { defaultValue: "待入库" }),
                key: 'EQ_subTransferPlanStatus',
                value: 20,
                spanKey: 'outboundedQty',
            }, {
                name: this.$t('fbb.alloment.inbounding', { defaultValue: "入库中" }),
                key: 'EQ_subTransferPlanStatus',
                value: 25,
                spanKey: 'inboundQty',
            }, {
                name: this.$t('global.common.finished', { defaultValue: "已完成" }),
                key: 'EQ_subTransferPlanStatus',
                value: 70,
                spanKey: 'completedQty',
            } , {
                name: this.$t('fbb.order.error_order', { defaultValue: "异常单据" }),
                key: 'NE_errorCode',
                value: 0,
                spanKey: 'errorQty',
            }]
        },
        ToolsData() {
            return [
                 {
                     name: this.$t('fbb.alloment.muti_audit', { defaultValue: "批量审核" }),
                     operate: "batchApprove",
                     theme: "primary",
                     batch: true,
                 },
                {
                    name: this.$t('fbb.alloment.muti_export', { defaultValue: "批量导出" }),
                    operate: "export",
                    // batch: true,
                },
            ]
        },
        SearchsData() {
            let widthStyle = 'width: 220px;'
            return [{
                    label: this.$t('fbb.alloment.alloment_order_number', { defaultValue: "调拨计划单号" }),
                    tag: 'vTextarea',
                    key: 'CN_subTransferPlanNo',
                    show: true,
                    props:{
                        placeholder: this.$t('fbb.inbound.input_more_line', { defaultValue: "输入多个，一行一个" }),
                        rows: 1,
                    },
                },
                {
                    label: this.$t('fbb.alloment.alloment_type', { defaultValue: "调拨类型" }),
                    tag: 'Select',
                    key: 'EQ_orderType',
                    options: this.getManageBillType,
                    props: {
                        filterable: true,
                    },
                    style: widthStyle
                },
                {
                    label: this.$t('fbb.costmanage.work_type', { defaultValue: "业务类型" }),
                    tag: 'Select',
                    key: 'orderTypes',
                    options: this.getFbaBillType,
                    props: {
                        filterable: true,
                    },
                    style: widthStyle
                },
                {
                    label: this.$t('global.common.source_number', { defaultValue: "来源单号" }),
                    tag: 'Input',
                    key: 'EQ_sourceNo',
                    style: widthStyle
                },
                {
                    label: "SKU",
                    tag: 'Input',
                    key: 'sku',
                    show: true,
                },
                {
                    label: this.$t('global.common.organization', { defaultValue: "组织" }),
                    tag: 'Select',
                    key: 'EQ_organizationId',
                    options: this.getSelfmanageorgList,
                    props: {
                        filterable: true,
                    },
                    style: widthStyle
                },
                {
                    label: this.$t('global.common.line', { defaultValue: "项目" }),
                    tag: 'Select',
                    key: 'EQ_lineId',
                    show: true,
                    options: this.getCusproductList,
                    props: {
                        filterable: true,
                    },
                },
                {
                    label: "Tracking NO",
                    tag: 'Input',
                    key: 'trackingNo',
                    style: widthStyle
                },
                {
                    label: "Shipment ID",
                    tag: 'Input',
                    key: 'EQ_shipmentId',
                    // options:[],
                    style: widthStyle
                },
                {
                    label: "Remove Order ID",
                    tag: 'Input',
                    key: "EQ_removeOrderId",
                    style: widthStyle
                },
                {
                    label: this.$t('fbb.inbound.inventory_type', { defaultValue: "库存类型" }),
                    tag: 'Select',
                    key: 'EQ_inventoryType',
                    options: this.getInventoryType,
                    style: widthStyle
                },
                {
                    label: this.$t('fbb.alloment.order_status', { defaultValue: "单据状态" }),
                    tag: 'Select',
                    key: 'IN_subTransferPlanStatus',
                    options: this.getFbaBillStatusSelect,
                    props: {
                        filterable: true,
                        multiple: true,
                    },
                    style: widthStyle
                },
                {
                    label: this.$t('fbb.inbound.errorcode', { defaultValue: "异常类型" }),
                    tag: 'Select',
                    key: 'error',
                    options: this.getErrorSimpleType,
                    style: widthStyle
                },
                {
                    label: this.$t('global.common.warehouse', { defaultValue: "仓库" }),
                    tag: 'Select',
                    key: 'EQ_orgWarehouseCode',
                    options: this.getUserManageWarehouseList,
                    props: {
                        filterable: true,
                    },
                    style: widthStyle
                },
                {
                    label: this.$t('fbb.transfer.istakepictures', { defaultValue: "是否拍照" }),
                    tag: "Select",
                    key: "EQ_hasPicture",
                    options: [
                        {
                            label: this.$t('erp.global.yes', { defaultValue: '是' }),
                            value: 1
                        },
                        {
                            label: this.$t('erp.global.no', { defaultValue: '否' }),
                            value: 0
                        }
                    ],
                    style: widthStyle
                },
                {
                    label: this.$t('fbb.transfer.ordinary_bol_check', { defaultValue: "是否上传Bol" }),
                    tag: "Select",
                    key: "EQ_isBol",
                    options: [
                        {
                            label: this.$t('erp.global.yes', { defaultValue: '是' }),
                            value: 1
                        },
                        {
                            label: this.$t('erp.global.no', { defaultValue: '否' }),
                            value: 0
                        }
                    ],
                    style: widthStyle
                },
               /*  {
                    label: "入库仓库",
                    tag: 'vSelect',
                    key: 'inWarehouseId',
                    options: this.getBillcusWareList,
                    props: {
                        filterable: true,
                    }
                }, */
                {
                    label: this.$t('fbb.alloment.warehouse_out_bound_at', { defaultValue: "预计出库日期" }),
                    tag: "vDatepicker",
                    key: "BT_warehouseEstimateOutboundAt",
                    props: {
                        options: this.options,
                        format: 'yy-mm-dd ~ yy-mm-dd',
                        confirm: false,
                    },
                    style: widthStyle
                },
                {
                    label: this.$t('global.common.createdtime', { defaultValue: "创建日期" }),
                    tag: 'vDatepicker',
                    key: 'BT_createdAt',
                    props: {
                        options: this.options,
                        format: 'yy-mm-dd 00:00:00 ~ yy-mm-dd 23:59:59',
                        confirm: false,
                    },
                    style: widthStyle
                },
                {
                    label: this.$t('global.common.update_time', { defaultValue: "更新日期" }),
                    tag: 'vDatepicker',
                    key: 'BT_updatedAt',
                    props: {
                        options: this.options,
                        format: 'yy-mm-dd 00:00:00 ~ yy-mm-dd 23:59:59',
                        confirm: false,
                    },
                    style: widthStyle
                },
            ]
        },
        columns() {
            return [
                {
                    type: 'selection',
                    width: 40,
                    align: 'center',
                    formName: 'id'
                },
                {
                    title: this.$t('global.common.operation', { defaultValue: '操作' }),
                    maxWidth: 90,
                    render: this.getOperateNodes
                },
                {
                    title: this.$t('fbb.alloment.client_organization', { defaultValue: '客户' }),
                    key: 'orgName',
                    width:120
                    // render: (h, { row }) => this.findRenderLabel(this.getOrgList, row.organizationId)
                },
                {
                    // title: '调拨计划单号/来源单号',
                    title: `${this.$t('fbb.alloment.alloment_order_number', { defaultValue: '调拨计划单号' })}/${this.$t('global.common.source_number', { defaultValue: '来源单号' })}`,
                    key: 'subTransferPlanNo',
                    width:200,
                    render: (h, { row }) => {
                        return <div>
                            <a onClick = {this.handleOperates.bind(this, { id:row.id, type: row.type, orderType: row.orderType}, 'query')}> {row.subTransferPlanNo || '--'} </a>
                            <a onClick = {this.handleOperates.bind(this, { id:row.id, type: row.type, orderType: row.orderType}, 'queryBlank')} ><vIcon class = "margin-left-10 font-14" type = "ios-browsers-outline" /> </a>
                            <br/> { row.sourceNo || '--'}
                            <br/><div><span style="color:red;">{this.findRenderLabel(this.getErrorSimpleType, row.errorCode)} </span> </div>
                        </div>
                    }
                },
                {
                    // title: '调拨类型/仓库',
                    title: `${this.$t('fbb.alloment.alloment_type', { defaultValue: '调拨类型' })}/${this.$t('global.common.warehouse', { defaultValue: '仓库' })}`,
                    width:200,
                    render: (h, {row}) => {
                        return <div>
                            <div> { this.findRenderLabel(this.getFbaBillType, row.type) } </div>
                            <div> { this.findRenderLabel(this.getBillType, row.orderType) } </div>
                            <div> { this.findRenderLabel(this.getUserManageWarehouseList, row.orgWarehouseCode)} </div>
                            </div>
                    }
                },
                {
                    title: this.$t('global.common.status', { defaultValue: '状态' }),
                    key: 'subTransferPlanStatus',
                    maxWidth: 80,
                    render: (h, {
                        row
                    }) => {
                        const status = row.subTransferPlanStatus;
                        const {
                            theme = 'default', label
                        } = this.getFbaBillStatusSelect.find(function (item) {
                            return item.value == status
                        }) || {};
                        return <vButton ghost theme = {
                            theme
                        }
                        size = "small"
                        class = "cursor-not width-60" > {
                            label
                        } </vButton>
                    }
                },
                {
                    // title: '项目/库存类型',
                    title: `${this.$t('global.common.line', { defaultValue: '项目' })}/${this.$t('fbb.inbound.inventory_type', { defaultValue: '        库存类型' })}`,
                    width: 80,
                    render: (h, {
                        row
                    }) => {
                        return <div>
                            <div> {
                                row.lineName
                            } </div> <div> {
                                this.findRenderLabel(this.getInventoryType, row.inventoryType)
                            } </div> </div>
                    }
                },
                {
                    title: 'Shipment ID / Remove Order ID',
                    key: 'shipmentId',
                    render(h, {
                        row
                    }) {
                        return <div>
                            <div> {
                                row.shipmentId || '--'
                            } </div> <div> {
                                row.removeOrderId || '--'
                            } </div> </div>
                    }
                },
                {
                    title: this.$t('global.common.update_time', { defaultValue: '更新时间' }),
                    key: 'updatedAt',
                    minWidth: 130,
                }
                /* ,{
                    title: '异常类型',
                    key: 'errorCode',
                    render: (h, {
                        row
                    }) => this.findRenderLabel(this.getErrorType, row.errorCode)
                },
                {
                    title: '异常原因',
                    key: 'errorReason',
                    sortable: true
                } */
            ];
        },
    },
};
